import React, { useState } from "react";
import QueryView from "../common/lib/QueryView";
import { useGetSites } from "../requests/useGetSites";
import { Site } from "../requests/useGetSites";
import { KAEmployeeLayout } from "./KAEmployeeLayout";

const KaEmployeeContainer: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const getSites = useGetSites();

  return <QueryView
    query={getSites}
    renderData={sites =>
      <SelectedSiteProvider defaultSite={sites[0]}>
        <KAEmployeeLayout
          sites={sites}>
          {children}
        </KAEmployeeLayout>
      </SelectedSiteProvider>
    }
  />
}

interface SiteContextType {
  selectedSite: Site;
  setSelectedSite: (site: Site) => void;
}

export const SelectedSiteContext = React.createContext<SiteContextType>({ selectedSite: { state: "", city: "", id: "", business: "", number: "", serviceContractNumber: "", admins: [] }, setSelectedSite: () => null });

export const SelectedSiteProvider: React.FC<{ defaultSite: Site, children?: React.ReactNode }> = ({ defaultSite, children }) => {
  const [selectedSite, setSelectedSite] = useState<Site>(defaultSite);

  return (
    <SelectedSiteContext.Provider value={{ selectedSite, setSelectedSite }}>
      {children}
    </SelectedSiteContext.Provider>
  );
};

export { KaEmployeeContainer };